// extracted by mini-css-extract-plugin
export default {"paperless-terms-modal":"PaperlessTermsModal_paperless-terms-modal__EUFwo","title":"PaperlessTermsModal_title__e-o0w"};